import InformationPageService from '@/api/InformationPageService';
import i18n from '@/i18n';
import cloneDeep from 'lodash/cloneDeep';

const state = {
  selectedPage: {
    name: 'PAGE_LABEL',
    sectionName: 'SECTION_NAME',
    title: '',
    contents: [],
  },
};

const getters = {
  getPageContentsOrdered: (state) => {
    const sortedContents = state.selectedPage.contents
      ? cloneDeep(state.selectedPage.contents)
      : [];
    sortedContents.sort(
      (a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0), // eslint-disable-line
    );
    return sortedContents;
  },
  formatCodeName: () => name => name.toUpperCase().replace(/-/g, '_'),
};

const actions = {
  init({ commit }) {
    commit('selectedPage', {
      name: 'PAGE_LABEL',
      sectionName: 'SECTION_NAME',
      title: i18n.t('PAGE.PAGE_LABEL'),
      contents: [],
    });
  },
  getPageInformation({ commit, dispatch }, args) {
    dispatch('init');
    return InformationPageService.getPageByName(args).then((response) => {
      commit('selectedPage', response.data);
    });
  },
};

const mutations = {
  selectedPage(state, payload) {
    state.selectedPage = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
